import { createFileRoute } from "@tanstack/react-router";
import { BabylonSceneWrapper } from "@/babylon/components/BabylonSceneWrapper";
import { OnBlurStrategy } from "@/pages/3d/memory/OnBlurStrategy";

export const Route = createFileRoute("/demo/3d/memory/on-blur")({
  component: () => (
    <BabylonSceneWrapper>
      <OnBlurStrategy />
    </BabylonSceneWrapper>
  ),
});
